import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { UpdateGroupPriceCategoryCommand } from '../../../../core/api/models/update-group-price-category-command';
import { GroupPriceCategoriesService } from '../../../../core/api/services/group-price-categories.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { CreateGroupPriceCategoryCommand } from './../../../../core/api/models/create-group-price-category-command';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-group-price-categories-form',
    templateUrl: './group-price-categories-form.component.html',
    styleUrls: ['./group-price-categories-form.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class GroupPriceCategoriesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: CreateGroupPriceCategoryCommand = {};
  categoryId: number;
  isUserForGroupPriceCopy: boolean;

  //#endregion

  constructor(
    protected currentService: GroupPriceCategoriesService,

    private dialogRef: MatDialogRef<GroupPriceCategoriesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    if (data.categoryName) this.model.categoryName = data.categoryName;
    if (data.isEdit) this.formPageConfig.isEditMode = data.isEdit;
    if (data.categoryId) this.categoryId = data.categoryId;
    if (data.isUserForGroupPriceCopy)
      this.isUserForGroupPriceCopy = data.isUserForGroupPriceCopy;
  }

  ngOnInit() {
    this.initForm();

    if (this.isUserForGroupPriceCopy) {
      this.formPageConfig.title = 'pages.groupPrice.form.fields.copyGroupPrice';
      return;
    }

    if (this.formPageConfig.isEditMode)
      this.formPageConfig.title =
        'pages.groupPrice.groupPriceCategories.form.editTitle';
    else
      this.formPageConfig.title =
        'pages.groupPrice.groupPriceCategories.form.addTitle';
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      categoryName: new FormControl('', Validators.required),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateGroupPriceCategoryCommand) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .groupPriceCategoriesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateGroupPriceCategoryCommand) {
    model.id = this.categoryId;
    this.unSubs();
    this.loading = true;
    this.currentService
      .groupPriceCategoriesUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Copy
  createGroupPriceCategoryByExistingCategoryApi(
    categoryId: number,
    newCategoryName: string
  ) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost({
        body: { categoryId: categoryId, newCategoryName: newCategoryName },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;

    if (this.isUserForGroupPriceCopy) {
      this.createGroupPriceCategoryByExistingCategoryApi(
        this.categoryId,
        this.model.categoryName
      );
      return;
    }

    this.checkCreateOrUpdate();
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
